import { GenericCard } from '~src/app/spaces/CardView/GenericCard';
import { DatabasesGraphQLResourceQuery } from '~src/catalog/fetchers/DatabasesGraphQLResourceQuery';
import { DatabasesWithCrass } from '~src/catalog/resources/DatabasesWithCrass';
import { Messages } from '~src/codegen/Localize';
import { ExplorableItemDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { DatabaseContentType,DatabaseWithCRASSSearchSubspaceType } from '~src/ts/models/ContentTypes';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const DatabaseWithCrassDefinition: ExplorableItemDefinition = {
  itemType: 'databaseWithCrass',
  pluralName: Messages.databasesAndFiles,
  singularName: Messages.database,
  emptyStateMessage: Messages.databasesAndFilesEmptyMessage,
  contentFilterKeys: DatabaseWithCRASSSearchSubspaceType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => {
    return DatabasesWithCrass.all().withExtraParams(DatabaseContentType.extraQueryParams);
  },
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
export const DatabaseDefinition: ExplorableItemDefinition = {
  itemType: 'database',
  pluralName: Messages.databasesAndFiles,
  singularName: Messages.database,
  emptyStateMessage: Messages.databasesAndFilesEmptyMessage,
  contentFilterKeys: DatabaseContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: GenericCard,
  listViewIconUrl: null,
  filterClause: null,
  getBasicQuery: () => new DatabasesGraphQLResourceQuery(),
  getContentInfo: () => {
  },
  supportedDisplayModes: ['list'],
};
